import React from 'react'
import { Card, CardContent, CardHeader, Progress, Table, Td, Th, Tr } from '@/shared/ui'
import type { RelatorioV2Row } from '../services/relatorioV2Service'
import { groupByKey, sortGroupsByTotalDesc } from '../utils/stats'
import { formatInt, formatPct01 } from '../utils/format'
import { computeMetrics } from '../utils/metrics'

export type BreakdownKey = {
  title: string
  keyLabel: string
  getKey: (row: RelatorioV2Row) => string
  top?: number
}

export default function OutcomeBreakdownTable({ rows, def }: { rows: RelatorioV2Row[]; def: BreakdownKey }) {
  const groups = sortGroupsByTotalDesc(groupByKey(rows, def.getKey))
  const limited = typeof def.top === 'number' ? groups.slice(0, Math.max(1, def.top)) : groups

  return (
    <Card>
      <CardHeader className="text-sm font-medium">{def.title}</CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <thead>
              <Tr>
                <Th>{def.keyLabel}</Th>
                <Th className="text-right">Total</Th>
                <Th className="text-right">Acerto%</Th>
                <Th className="text-right">Stop%</Th>
                <Th className="text-right">TP3</Th>
                <Th className="text-right">TP2</Th>
                <Th className="text-right">TP1</Th>
                <Th className="text-right">Stop</Th>
                <Th className="min-w-[160px]">Barra (acerto)</Th>
              </Tr>
            </thead>
            <tbody>
              {limited.map((g) => {
                const m = computeMetrics(g.rows)
                return (
                  <Tr key={g.key}>
                    <Td className="max-w-[260px] truncate" title={g.key}>
                      {g.key}
                    </Td>
                    <Td className="text-right">{formatInt(m.total)}</Td>
                    <Td className="text-right">{formatPct01(m.winPct)}</Td>
                    <Td className="text-right">{formatPct01(m.stopPct)}</Td>
                    <Td className="text-right">{formatInt(m.tp3Hit)}</Td>
                    <Td className="text-right">{formatInt(m.tp2Hit)}</Td>
                    <Td className="text-right">{formatInt(m.tp1Hit)}</Td>
                    <Td className="text-right">{formatInt(m.stopOnly)}</Td>
                    <Td>
                      <Progress value={m.winPct * 100} />
                    </Td>
                  </Tr>
                )
              })}
            </tbody>
          </Table>
        </div>
      </CardContent>
    </Card>
  )
}
